import { HFlow, Omit, Text } from 'bold-ui'
import { DEFAULT_SELECT_SIZE, useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { EquipeAdSelectFieldDocument } from 'graphql/hooks.generated'
import { EquipeAdSelectFieldQuery, EquipeAdSelectFieldQueryVariables } from 'graphql/types.generated'
import React from 'react'
import { capitalize } from 'util/strConversor'

export type EquipeSelectModel = EquipeAdSelectFieldQuery['equipesAD']['content'][0]

export interface EquipeSelectFieldProps extends Omit<SelectFieldProps<EquipeSelectModel>, 'items' | 'itemToString'> {
  localidadeId?: ID
  equipeId?: ID
  mostrarEquipesRelacionadas?: boolean
}

export function EquipeAdSelectField(props: EquipeSelectFieldProps) {
  const { localidadeId, equipeId, mostrarEquipesRelacionadas, ...rest } = props

  const asyncProps = useAsyncQuerySelect<
    EquipeSelectModel,
    EquipeAdSelectFieldQuery,
    EquipeAdSelectFieldQueryVariables
  >({
    query: EquipeAdSelectFieldDocument,
    extractItems: (data) => data?.equipesAD?.content,
    variables: (inputQuery) => ({
      input: {
        query: inputQuery,
        mostrarEquipesRelacionadas,
        localidadeId,
        equipeId,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
          sort: ['nome'],
        },
      },
    }),
  })

  const itemToString = (option: EquipeSelectModel) => option?.nome

  const renderItem = (item: EquipeSelectModel) => (
    <>
      <Text fontWeight='bold'>
        {capitalize(item.nome)} – {item.tipoEquipe.sigla}
      </Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>INE:</Text>
        {item.ine}
      </HFlow>
    </>
  )

  return (
    <SelectField<EquipeSelectModel> itemToString={itemToString} renderItem={renderItem} {...asyncProps} {...rest} />
  )
}
